module.exports = __webpack_public_path__ + "3256f7aa398677faf6268cb044d7c76c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service.png
// module id = 176
// module chunks = 1